module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer1347"
    }
  }, [_c('p', {
    staticClass: "structure-bnxt1",
    attrs: {
      "id": "calibre_pb_29"
    }
  }, [_c('span', {
    staticClass: "bold1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body_heading"
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("Dirty Dozen plus One")])]), _vm._v(" "), _c('p', {
    staticClass: "icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("1.")]), _vm._v("St"), _c('span', [_vm._v("rawberries")])]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('a', {
    attrs: {
      "href": "https://www.ewg.org/foodnews/spinach.php",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("2.")]), _vm._v("Spinach")])]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("3.")]), _vm._v("Kale")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("4.")]), _c('span', [_vm._v("Nectarines")])]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("5.")]), _vm._v("Apples")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("6.")]), _vm._v("Grapes")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("7.")]), _vm._v("Peaches")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("8.")]), _vm._v("Cherries")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("9.")]), _vm._v("Pears")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("10.")]), _vm._v("Tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("11.")]), _vm._v("Celery")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers"
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("12.")]), _vm._v("Potatoes")]), _vm._v(" "), _c('p', {
    staticClass: "body_numbers1",
    attrs: {
      "id": "calibre_pb_30"
    }
  }, [_c('span', {
    staticClass: "bold3"
  }, [_vm._v("13.")]), _vm._v("Sweet be"), _c('span', [_vm._v("ll")]), _c('span'), _c('span', [_vm._v("peppers")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-303fa573","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/5Ingredient_split_017.vue
// module id = 108
// module chunks = 0